import Vue from 'vue'
import {STORAGE_KEY} from '../constants/App'
import Modal from '../components/common/Modal'

/** アプリケーション共通ユーティリティ */

/**
 * ローカルモード判定
 */
export const isLocal = () => {
  return process.env.NODE_ENV === 'local'
}

/**
 * 開発モード判定
 */
export const isDev = () => {
  return process.env.NODE_ENV === 'development'
}

/**
 * darosの画像のURLを取得
 */
export const getDarosResource = (imagePath) => {
  return process.env.RESOURCE_URL + 'imgs/daros/' + imagePath
}

/**
 * mmstyleの画像のURLを取得
 */
export const getMmstyleResource = (imagePath) => {
  return process.env.RESOURCE_URL + 'imgs/mmstyle/' + imagePath
}

/**
 * sketchorderの画像のURLを取得
 */
export const getSketchResource = (imagePath) => {
  return process.env.RESOURCE_URL + 'imgs/sketchorder/' + imagePath
}

/**
 * mmstyleのコンテンツを取得
 */
export const getMmstyleContents = (content) => {
  return process.env.RESOURCE_URL + 'contents/mmstyle/' + content
}

/**
 * kagullの画像のURLを取得
 */
export const getKagullResource = (imagePath) => {
  return process.env.RESOURCE_URL + 'imgs/kagull/' + imagePath
}

/**
 * コンテンツの画像のURLを取得
 */
export const getContentsResource = (imagePath) => {
  return process.env.RESOURCE_URL + 'contents/' + imagePath
}

/**
 * コンテンツのスケッチオーダー画像のURLを取得
 */
export const getContentsSkupResource = (imagePath) => {
  return process.env.RESOURCE_URL + 'contents/skup/' + imagePath
}

/**
 * ログインユーザー情報取得
 * ※設定箇所はLogin.vue参照
 * @return { corpName, userName }
 */
export const getUserInfo = () => {
  let userInfo = localStorage.getItem(STORAGE_KEY.USER_INFO)
  return userInfo ? JSON.parse(userInfo) : {}
}

/**
 * ローカルストレージ取得
 * @return
 */
export const getLocalStorage = (key) => {
  let json = localStorage.getItem(key)
  return json ? JSON.parse(json) : {}
}

/**
 * ローカルストレージ上書設定
 * @return
 */
export const setLocalStorage = (key, obj) => {
  return localStorage.setItem(key, JSON.stringify(obj))
}

/**
 * ローカルストレージ追加設定
 * @return
 */
export const addLocalStorage = (key, addObj) => {
  let json = localStorage.getItem(key)
  let obj = json ? JSON.parse(json) : {}
  let merged = Object.assign(obj, addObj)
  return localStorage.setItem(key, JSON.stringify(merged))
}

/**
 * ローカルストレージ削除
 * @return
 */
export const removeLocalStorage = (key) => {
  return localStorage.removeItem(key)
}

/**
 * 共通モーダル表示
 * 利用方法：
 * let modalData = {
 *   title: 'タイトル',
 *   messages: ['メッセージ', '複数項目に分けて引渡すと改行して表示する'],
 *   modalType: 'message', // or 'confirm'
 *   messageType: 'info', // or 'success' or 'error'
 *   textAlign: 'center', // or 'left'
 *   onOk: () => { OKボタン押下時のコールバック関数を定義 },
 *   onCancel: () => { キャンセルボタン押下時のコールバック関数を定義 },
 *   callbackParams: { コールバック関数に渡す引数を定義 }
 * }
 * App.showModal(modalData)
 */
export const showModal = (modalData) => {
  let modal = new Vue({
    el: '#modal',
    components: { 'dd-modal': Modal },
    data () {
      return {
        modalData: modalData
      }
    },
    template: `
      <dd-modal
        :title="modalData.title"
        :messages="modalData.messages"
        :modalType="modalData.modalType"
        :messageType="modalData.messageType"
        :textAlign="modalData.textAlign"
        :okBtnLabel="modalData.okBtnLabel"
        :cancelBtnLabel="modalData.cancelBtnLabel"
        :onOk="modalData.onOk"
        :onCancel="modalData.onCancel"
        :callbackParams="modalData.callbackParams"
      />
    `
  }).$children[0]
  modal.showModal()
}

/**
 * 配列をgroup byして返す
 * @param xs 配列
 * @param key keyにする要素
 * @returns key, objの配列を返す
 */
export const groupBy = (xs, key) => {
  return xs.reduce(function (rv, x) {
    (rv[x[key]] = rv[x[key]] || []).push(x)
    return rv
  }, {})
}



// WEBPACK FOOTER //
// ./src/main/js/utils/App.js